import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import {MapAction} from '../Actions/Models/MapActionModel';
import {Types} from 'Modules/MapModule';
import {minZoom, maxZoom} from 'components/Map/MapHelpers/MapHelpers';

export type State = Types.MapStore;
export const initialState: State = {
    center: {
        lat: 51.16,
        lng: 18.5
    },
    ref: null,
    bounds: null,
    zoom: 6,
    smallMap: {
        center: {
            lat: 51.16,
            lng: 18.5
        },
        zoom: 6,
        ref: null,
        bounds: null
    },
    minZoomToShowDirectionsOnTrack: 15
};

export function mapReducer(state: State = initialState, action: MapAction): State {
    switch (action.type) {
        case ActionTypes.MAP.SET_CENTER:
            if (action.payload.zoom === null) {
                return {
                    ...state,
                    center: action.payload.center
                };
            } else {
                return {
                    ...state,
                    center: action.payload.center,
                    zoom: action.payload.zoom
                };
            }
        case ActionTypes.MAP.SET_ZOOM:
            return {
                ...state,
                zoom: action.payload.zoom
            };
        case ActionTypes.MAP.MANAGE_ZOOM: {
            let newZoom: number = state.zoom;
            if (action.payload.type === 'add' && newZoom < maxZoom) {
                newZoom++;
            } else if (action.payload.type === 'substract' && newZoom > minZoom) {
                newZoom--;
            }
            return {
                ...state,
                zoom: newZoom
            };
        }

        case ActionTypes.MAP.SMALL_MAP_SET_CENTER:
            return {
                ...state,
                smallMap: {
                    ...state.smallMap,
                    center: action.payload.center
                }
            };
        case ActionTypes.MAP.SMALL_MAP_SET_ZOOM:
            return {
                ...state,
                smallMap: {
                    ...state.smallMap,

                    zoom: action.payload.zoom
                }
            };
        case ActionTypes.MAP.SMALL_MAP_MANAGE_ZOOM: {
            let newZoom: number = state.smallMap.zoom;
            if (action.payload.type === 'add' && newZoom < maxZoom) {
                newZoom++;
            } else if (action.payload.type === 'substract' && newZoom > minZoom) {
                newZoom--;
            }
            return {
                ...state,
                smallMap: {
                    ...state.smallMap,

                    zoom: newZoom
                }
            };
        }
        case ActionTypes.MAP.SET_MAP_REF: {
            return {
                ...state,
                ref: action.payload.map
            };
        }
        case ActionTypes.MAP.SET_SMALL_MAP_REF: {
            return {
                ...state,
                smallMap: {
                    ...state.smallMap,
                    ref: action.payload.map
                }
            };
        }
        case ActionTypes.MAP.SET_MAP_LATEST_BOUNDS: {
            return {
                ...state,
                bounds: action.payload.bounds
            };
        }
        case ActionTypes.MAP.SET_SMALL_MAP_LATEST_BOUNDS: {
            return {
                ...state,
                smallMap: {
                    ...state.smallMap,
                    bounds: action.payload.bounds
                }
            };
        }
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/MapReducer.ts